<div id="arena" [ngStyle]="{ overflow: 'scroll', display: !noLayoutPath ? 'block' : 'none' }">
  <dx-scroll-view> <ng-container #dynamic></ng-container></dx-scroll-view>
</div>
@if (displayProgressbar) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}
<div class="noDataPlaceHolder" [ngStyle]="{ display: noLayoutPath ? 'block' : 'none' }">
  &lt;{{ res.get('ObjectInfo-NoData') }}&gt;
</div>
